import { FC, useEffect, useState } from 'react'

interface ResendVerificationButtonProps {
  onResend: () => Promise<void>
  disabled?: boolean
  className?: string
  cooldownTime?: number
}

const ResendVerificationButton: FC<ResendVerificationButtonProps> = ({
  onResend,
  disabled = false,
  className = '',
  cooldownTime = 60
}) => {
  const [cooldown, setCooldown] = useState(cooldownTime)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (cooldown > 0) {
      timer = setInterval(() => {
        setCooldown(prev => prev - 1)
      }, 1000)
    }
    return () => {
      if (timer) clearInterval(timer)
    }
  }, [cooldown])

  const handleResend = async () => {
    try {
      setIsLoading(true)
      await onResend()
      setCooldown(cooldownTime)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className={`text-[rgba(0,0,0,0.5)] select-none ${className}`}>
      Haven't got the email yet?{' '}
      <button
        onClick={handleResend}
        className='text-blue-600 underline disabled:opacity-50 disabled:cursor-not-allowed select-none'
        disabled={disabled || isLoading || cooldown > 0}
      >
        Resend email{cooldown > 0 ? ` (${cooldown}s)` : ''}
      </button>
    </div>
  )
}

export default ResendVerificationButton
